export let SignupPlan = /*#__PURE__*/function (SignupPlan) {
  SignupPlan["STARTER"] = "starter";
  SignupPlan["CORE"] = "core";
  SignupPlan["PREMIUM"] = "premium";
  return SignupPlan;
}({});
export let SignupCurrency = /*#__PURE__*/function (SignupCurrency) {
  SignupCurrency["EUR"] = "eur";
  SignupCurrency["USD"] = "usd";
  return SignupCurrency;
}({});